import Blockquote from '@tiptap/extension-blockquote';

const BlockquoteExtension = Blockquote.extend({
  content: 'paragraph',
});

export default BlockquoteExtension;
